<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :loading="isLoading"
    routeback="/fornecedor/cadastro/formas-entrega"
  >
    <div v-if="mode == 'detail'">
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        sortBy="descricaoFormaTransporte"
        :sortDesc="false"
        ref="datatable"
        search
        :limitPage="[10, 25, 50, 100, 200]"
      >
        <template v-slot:custo_transporte="{ col }">
          {{ col | formatMoney }}
        </template>
        <template v-slot:custo_percentual_seguro="{ col }">
          {{ col | formatMoney }}
        </template>
        <template v-slot:total_pedido_inicial="{ col }">
          {{ col | formatMoney }}
        </template>
        <template v-slot:total_pedido_final="{ col }">
          {{ col | formatMoney }}
        </template>
      </DataTable>
    </div>
    <div v-else-if="mode != 'simulation'">
      <h4 class="text-center">Dados básicos</h4>
      <LineDivider></LineDivider>
      <v-row justify="center" v-if="mode != 'edit'">
        <FormRadioGroup
          v-model="form.tipo"
          inline
          :radios="formasEntregas.filter(f => f.show)"
        />
      </v-row>
      <v-window v-model="form.tipo">
        <v-window-item
          v-for="(f, i) in formasEntregas.filter(f => f.show)"
          :key="i"
          :value="f.value"
        >
          <FormaEntregaFormDelivery
            v-if="f.value == 'DELIVERY'"
            :calendarios="calendarios"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormRetirada
            v-if="f.value == 'RETIRADA'"
            :calendarios="calendarios"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormTransporte
            v-if="f.value == 'TRANSPORTE'"
            :calendarios="calendarios"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormCorreios
            v-if="f.value == 'CORREIOS'"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormFrenet
            v-if="f.value == 'FRENET'"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormCliente
            v-if="f.value == 'BASEADA_CLIENTE'"
            ref="formaEntregaClienteForm"
            :calendarios="calendarios"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormIntelipost
            v-if="f.value == 'INTELIPOST'"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormFreteRapido
            v-if="f.value == 'FRETE_RAPIDO'"
            :data="form"
            @update="updateValues"
          />
          <FormaEntregaFormShippify
            v-if="f.value == 'SHIPPIFY'"
            :data="form"
            @update="updateValues"
          />
        </v-window-item>
      </v-window>
      <FormSelect
        data-test="canais-venda-select"
        label="Canais de venda"
        v-model="form.canais_venda"
        :options="canaisVendaOptions"
        :multiple="true"
        :help="mensagemAjudaCanaisVenda"
      />
      <FormSwitch
        data-test="tipo-frete-switch"
        v-model="form.informarTipoFrete"
        label="Informar tipo de frete"
        :help="mensagemAjudaTipoFrete"
        :readonly="mode == 'detail'"
      />
      <FormRadioGroup
        v-if="form.informarTipoFrete"
        data-test="tipo-frete-radio"
        v-model="form.tipoFrete"
        inline
        :radios="tiposFreteOptions"
        :readonly="mode == 'detail'"
      />
    </div>
    <div v-else>
      <FormaEntregaFormSimulacao ref="formSimulacao" />
    </div>
    <template v-slot:buttons>
      <FormButton
        text="Salvar"
        submit
        type="submissao"
        v-if="mode != 'simulation' && mode != 'detail'"
      />
      <FormButton
        v-else-if="mode != 'detail'"
        text="Simular"
        type="primario"
        @click="onSubmitSimulation"
      />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import LineDivider from "@/components/LineDivider";
import FormButton from "@/components/form/FormButton";
import FormRadioGroup from "@/components/form/FormRadioGroup";
import FormSwitch from "@/components/form/FormSwitch";
import FormSelect from "@/components/form/FormSelect";
import DataTable from "@/components/DataTable";
import FormaEntregaFormDelivery from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormDelivery";
import FormaEntregaFormRetirada from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormRetirada";
import FormaEntregaFormCliente from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormCliente";
import FormaEntregaFormCorreios from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormCorreios";
import FormaEntregaFormFrenet from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormFrenet";
import FormaEntregaFormIntelipost from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormIntelipost";
import FormaEntregaFormTransporte from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormTransporte";
import FormaEntregaFormSimulacao from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormSimulacao";
import FormaEntregaFormFreteRapido from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormFreteRapido.vue";
import FormaEntregaFormShippify from "@/pages/cadastro/formasentrega/forms/FormaEntregaFormShippify.vue";
import { validarDetalhesTransporteCliente } from "@/pages/cadastro/formasentrega/utils/validarFormaTransporteCliente";
import { CANAIS_VENDA_TODOS, CANAIS_VENDA_OPTIONS } from "@/utils/canais-venda";
import {
  normalizeCanaisVendaFromApi,
  buildCanaisVendaPayload
} from "@/pages/cadastro/formasentrega/canais-venda-helpers";
import * as _ from "lodash";
import { mapGetters } from "vuex";
import {
  FORMA_ENTREGA_CREATE,
  FORMA_ENTREGA_UPDATE,
  FORMA_ENTREGA_LOAD,
  FORMASENTREGAS,
  FORMA_ENTREGA_CALENDARIO_LIST,
  FORMA_ENTREGA_FORNECEDOR,
  FORMA_ENTREGA_FORMAS_LIST
} from "@/store/actions/formasEntrega";

export default {
  name: "FormaEntregaForm",
  components: {
    SidePopup,
    LineDivider,
    FormButton,
    FormRadioGroup,
    FormSwitch,
    FormSelect,
    DataTable,
    FormaEntregaFormDelivery,
    FormaEntregaFormRetirada,
    FormaEntregaFormCliente,
    FormaEntregaFormCorreios,
    FormaEntregaFormFrenet,
    FormaEntregaFormIntelipost,
    FormaEntregaFormTransporte,
    FormaEntregaFormSimulacao,
    FormaEntregaFormFreteRapido,
    FormaEntregaFormShippify
  },
  data: () => ({
    mode: "edit",
    isLoading: false,
    canaisVendaOptions: CANAIS_VENDA_OPTIONS,
    tiposFreteOptions: [
      { label: "CIF", value: "CIF" },
      { label: "FOB", value: "FOB" }
    ],
    mensagemAjudaTipoFrete:
      "Enviado ao ERP somente em pedidos feitos pelo LifeGrowth. Alterações valem apenas para pedidos novos.",
    mensagemAjudaCanaisVenda:
      "Nesta versão, apenas o canal LifeGrowth pode ser desmarcado. Site, App, Integração, Venda+ e Vendedor permanecem sempre habilitados para os demais canais de venda.",
    headers: [
      {
        text: "Descrição da forma de transporte",
        value: "descricao_forma_transporte"
      },
      { text: "CEP Inicial", value: "cep_inicial" },
      { text: "CEP Final", value: "cep_final" },
      { text: "Custo transporte", value: "custo_transporte" },
      { text: "Custo percentual do seguro", value: "custo_percentual_seguro" },
      { text: "Peso Inicial", value: "peso_inicial" },
      { text: "Peso Final", value: "peso_final" },
      { text: "Quantidade de dias de preparo", value: "quant_dias_preparo" },
      { text: "Quantidade de dias de entrega", value: "quant_dias_entrega" },
      { text: "Total inicial do pedido", value: "total_pedido_inicial" },
      { text: "Total final do pedido", value: "total_pedido_final" }
    ],
    formSimulacao: {
      tipo: ""
    },
    form: {
      nome: "",
      nomeForma: "",
      idFormaEntregaErp: null,
      tipo: null,
      idfornecedor: null,
      idCalendarioEntrega: null,
      detalhesCustoTransporte: [],
      permiteAgendamento: false,
      id: null,
      canais_venda: [...CANAIS_VENDA_TODOS],
      informarTipoFrete: false,
      tipoFrete: null,
      taxaConveniencia: null,
      taxaExtraPorMetro: null,
      taxaColeta: null,
      correios: {
        usuario: "",
        senha: "",
        cartaoPostagem: "",
        cepOrigem: "",
        acrescimoTaxa: 0,
        diasSeparacao: 1,
        metodoCalculo: "SOMA_CUSTO_POR_PRODUTO",
        valorDeclarado: "NAO_DECLARAR_VALOR",
        opcoes: {
          servicos: []
        }
      },
      currentFile: null,
      encoding: "utf8",
      frenet: {
        token: "",
        cepOrigem: "",
        acrescimoTaxa: 0,
        diasSeparacao: 1,
        transportadoras: [],
        permiteRestricoesFrenet: false
      },
      intelipost: {
        token: "",
        cepOrigem: "",
        acrescimoTaxa: 0,
        diasSeparacao: 1,
        metodoCalculo: "DYNAMIC_BOX_ALL_ITEMS"
      },
      baseadaCliente: {
        idSegmentoCliente: null,
        formas: []
      },
      freteRapido: {
        cnpj: "",
        token: "",
        platformCode: "",
        cepOrigem: "",
        layoutEtiqueta: "",
        formatoEtiqueta: "",
        acrescimoTaxa: 0,
        diasSeparacao: 1,
        transportadoras: []
      },
      shippify: {
        apiId: "",
        apiToken: "",
        companyId: "",
        pickupContactName: "",
        pickupContactEmail: "",
        pickupContactPhone: "",
        pickupAddress: "",
        pickupInstructions: "",
        pickupLat: "",
        pickupLng: "",
        acrescimoTaxa: 0,
        diasSeparacao: 1,
        tipoCotacao: "",
        valorMinimoFreteGratis: "",
        raioFreteGratis: "",
        nomeFreteGratis: "",
        dimensoesPacotes: {
          extraPequeno: {
            volume: 0.0017
          },
          pequeno: {
            volume: 0.0078
          },
          medio: {
            volume: 0.0553
          },
          grande: {
            volume: 0.2074
          },
          extraGrande: {
            volume: 0.4977
          }
        }
      }
    },
    calendarios: []
  }),
  methods: {
    getFormaEntregaClienteFormRef() {
      const ref = this.$refs.formaEntregaClienteForm;
      if (Array.isArray(ref)) {
        return ref.find(component => component) || ref[0];
      }
      return ref;
    },
    onClose(routeBack = false) {
      this.isLoading = false;
      this.$emit("close");
      if (routeBack) {
        this.$router.replace("/fornecedor/cadastro/formas-entrega");
      }
    },
    onSubmitSimulation() {
      this.$refs.formSimulacao.$emit("clickSubmit");
    },
    onSubmit() {
      if (!this.validarFormaEntrega()) return;
      this.isLoading = true;
      let formaEntrega = this.prepareOpcoes(this.form);
      if (this.mode == "edit" && formaEntrega.id) {
        this.$store
          .dispatch(FORMA_ENTREGA_UPDATE, formaEntrega)
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              "Forma de entrega atualizada com sucesso"
            );
            this.onClose(true);
          })
          .catch(err => {
            const erro =
              err.response.data.Mensagem ||
              err.response.data ||
              "Erro ao atualizar forma de entrega";
            this.$vueOnToast.pop("error", erro);
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch(FORMA_ENTREGA_CREATE, formaEntrega)
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              "Forma de entrega criada com sucesso"
            );
            this.onClose(true);
          })
          .catch(err => {
            const erro =
              err.response.data.Mensagem ||
              err.response.data ||
              "Erro ao criar forma de entrega";
            this.$vueOnToast.pop("error", erro);
            this.isLoading = false;
          });
      }
    },
    getData(id) {
      this.isLoading = true;
      this.$store
        .dispatch(FORMA_ENTREGA_LOAD, id)
        .then(data => {
          this.setFormaEntregaForm(data);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.onClose();
        });
    },
    getFornecedor() {
      this.isLoading = true;
      this.$store
        .dispatch(FORMA_ENTREGA_FORNECEDOR)
        .then(data => {
          if (data) {
            const {
              taxa_coleta,
              taxaconveniencia,
              taxa_extra_por_metro,
              quantidade_delivery,
              quantidade_retirada,
              idareavendafornecedor,
              distancia_taxa_entrega_base,
              distancia_pedido_minimo_base,
              acrescimo_ped_min_por_metro,
              valormaxpedido,
              valorminpedido,
              valormaxpedido_retirada,
              valorminpedido_retirada
            } = data;

            this.form = {
              ...this.form,
              taxaColeta: taxa_coleta,
              taxaConveniencia: taxaconveniencia,
              taxaExtraPorMetro: taxa_extra_por_metro * 1000 || 0,
              acrescimoPedMinimoPorKm: acrescimo_ped_min_por_metro * 1000 || 0,
              valorMaxPedido: valormaxpedido || 999999,
              valorMinPedido: valorminpedido || 0,
              valorMaxPedidoRetirada: valormaxpedido_retirada || 999999,
              valorMinPedidoRetirada: valorminpedido_retirada || 0
            };

            if (idareavendafornecedor) {
              this.form = {
                ...this.form,
                idareavendafornecedor: idareavendafornecedor,
                distanciaTaxaEntrega: distancia_taxa_entrega_base || 0,
                distanciaPedidoMinimo: distancia_pedido_minimo_base || 0
              };
            }

            this.form.showDelivery = Number(quantidade_delivery) == 0;
            this.form.showRetirada = Number(quantidade_retirada) == 0;
          }
          let { idformaentrega } = this.$route.params;
          let { detalhes } = this.$route.query;
          if (detalhes) {
            this.mode = "detail";
          } else if (idformaentrega === "novo") {
            this.mode = "add";
          } else if (idformaentrega === "simulacao") {
            this.mode = "simulation";
          } else {
            this.mode = "edit";
            this.getData(idformaentrega);
          }
          if (this.mode !== "edit") {
            const getDefaultType = () => {
              if (this.form.showDelivery) return "DELIVERY";
              if (this.form.showRetirada) return "RETIRADA";
              return "TRANSPORTE";
            };
            this.form.tipo = getDefaultType();
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getDetalhesCustoTransporte(idformaentrega) {
      this.isLoading = true;
      const body = {
        columns: [
          {
            data: "descricao_forma_transporte",
            name: "",
            orderable: "true",
            search: { value: "", regex: "false" },
            searchable: "true"
          }
        ],
        draw: "1",
        length: "100",
        order: [
          {
            column: "0",
            dir: "asc"
          }
        ],
        search: { value: "", regex: "false" },
        start: "0"
      };
      this.$store
        .dispatch(FORMA_ENTREGA_FORMAS_LIST, { idformaentrega, body })
        .then(result => {
          const formas = (_.get(result, "data") || []).map(d => ({
            descricaoFormaTransporte: d.descricao_forma_transporte,
            cepInicial: this.maskCep(d.cep_inicial),
            cepFinal: this.maskCep(d.cep_final),
            custoTransporte: d.custo_transporte,
            custoPercentualSeguro: d.custo_percentual_seguro,
            pesoInicial: d.peso_inicial,
            pesoFinal: d.peso_final,
            quantDiasPreparo: d.quant_dias_preparo,
            quantDiasEntrega: d.quant_dias_entrega,
            totalPedidoInicial: d.total_pedido_inicial,
            totalPedidoFinal: d.total_pedido_final
          }));
          this.form.baseadaCliente.formas = formas;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getCalendarios() {
      this.isLoading = true;
      this.$store
        .dispatch(FORMA_ENTREGA_CALENDARIO_LIST)
        .then(data => {
          this.calendarios = (data || []).map(v => {
            return { value: v.idCalendarioEntrega, text: v.nomeCalendario };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    updateValues(valores) {
      this.form = {
        ...this.form,
        ..._.omit(valores, ["canais_venda", "informarTipoFrete", "tipoFrete"])
      };
    },
    setFormaEntregaForm(formaEntrega) {
      this.form.id = formaEntrega.id;
      this.form.nomeForma = formaEntrega.nomeForma;
      this.form.idFormaEntregaErp = formaEntrega.idFormaEntregaErp;
      this.form.idCalendarioEntrega = formaEntrega.idCalendarioEntrega;
      this.form.permiteAgendamento = !!formaEntrega.idCalendarioEntrega;
      this.form.tipo = formaEntrega.tipo;
      this.form.idfornecedor =
        formaEntrega.idfornecedor || this.getFornecedorId;
      this.form.canais_venda = normalizeCanaisVendaFromApi(
        formaEntrega.canais_venda
      );
      this.form.tipoFrete = formaEntrega.tipoFrete || null;
      this.form.informarTipoFrete = !!this.form.tipoFrete;
      const credenciais = formaEntrega.credenciais || {};
      const opcoes = formaEntrega.opcoesConfiguracao || {};
      switch (formaEntrega.tipo) {
        case "CORREIOS":
          this.form.correios = {
            usuario: credenciais.usuario,
            senha: credenciais.senha,
            cartaoPostagem: credenciais.cartaoPostagem,
            cepOrigem: this.maskCep(opcoes.cepOrigem),
            metodoCalculo: opcoes.metodoCalculo || "SOMA_CUSTO_POR_PRODUTO",
            valorDeclarado: opcoes.valorDeclarado || "NAO_DECLARAR_VALOR",
            opcoes: {
              servicos: opcoes.servicos
            },
            acrescimoTaxa: opcoes.acrescimoTaxa,
            diasSeparacao: opcoes.diasSeparacao
          };
          break;
        case "BASEADA_CLIENTE":
          if (formaEntrega.detalhesCustoTransporte) {
            this.form.baseadaCliente = {
              formas: formaEntrega.detalhesCustoTransporte,
              idSegmentoCliente: opcoes.idSegmentoCliente
            };
          } else {
            this.form.baseadaCliente = {
              formas: [],
              idSegmentoCliente: opcoes.idSegmentoCliente
            };
            this.getDetalhesCustoTransporte(this.form.id);
          }
          break;
        case "FRENET":
          this.form.frenet = {
            token: credenciais.token,
            cepOrigem: this.maskCep(opcoes.cepOrigem),
            diasSeparacao: opcoes.diasSeparacao,
            acrescimoTaxa: opcoes.acrescimoTaxa,
            transportadora: {
              idtransportadora: null,
              nome: "",
              codigoHub: "",
              codigoErp: ""
            },
            transportadoras: formaEntrega.transportadoras || [],
            permiteRestricoesFrenet:
              String(_.get(opcoes, "permiteRestricoesFrenet", "false")) ===
              "true"
          };
          break;
        case "INTELIPOST":
          this.form.intelipost = {
            token: credenciais.token,
            cepOrigem: this.maskCep(opcoes.cepOrigem),
            diasSeparacao: opcoes.diasSeparacao,
            acrescimoTaxa: opcoes.acrescimoTaxa,
            metodoCalculo: opcoes.metodoCalculo
          };
          break;
        case "TRANSPORTE":
          break;
        case "DELIVERY":
          this.form.valorMaxPedido = this.form.valorMaxPedido;
          this.form.valorMinPedido = this.form.valorMinPedido;
          this.form.distanciaPedidoMinimo = this.form.distanciaPedidoMinimo;
          this.form.acrescimoPedMinimoPorKm = this.form.acrescimoPedMinimoPorKm;
          this.form.taxaConveniencia = this.form.taxaConveniencia;
          this.form.distanciaTaxaEntrega = this.form.distanciaTaxaEntrega;
          this.form.taxaExtraPorMetro = this.form.taxaExtraPorMetro;
          break;
        case "RETIRADA":
          this.form.valorMaxPedidoRetirada = this.form.valorMaxPedidoRetirada;
          this.form.valorMinPedidoRetirada = this.form.valorMinPedidoRetirada;
          this.form.taxaColeta = this.form.taxaColeta;
          break;
        case "FRETE_RAPIDO":
          this.form.freteRapido = {
            cnpj: credenciais.cnpj,
            token: credenciais.token,
            platformCode: credenciais.platformCode,
            cepOrigem: this.maskCep(opcoes.cepOrigem),
            layoutEtiqueta: opcoes.layoutEtiqueta,
            formatoEtiqueta: opcoes.formatoEtiqueta,
            diasSeparacao: opcoes.diasSeparacao,
            acrescimoTaxa: opcoes.acrescimoTaxa,
            transportadoras: formaEntrega.transportadoras || [],
            consolidate: opcoes.consolidate || false,
            overlaid: opcoes.overlaid || false,
            rotate: opcoes.rotate || false
          };
          break;
        case "SHIPPIFY":
          this.form.shippify = {
            apiId: credenciais.apiId || "",
            apiToken: credenciais.apiToken || "",
            companyId: credenciais.companyId || "",
            pickupContactName: opcoes.pickupContactName || "",
            pickupContactEmail: opcoes.pickupContactEmail || "",
            pickupContactPhone: opcoes.pickupContactPhone || "",
            pickupAddress: opcoes.pickupAddress || "",
            pickupInstructions: opcoes.pickupInstructions || "",
            pickupLat: opcoes.pickupLat || "",
            pickupLng: opcoes.pickupLng || "",
            acrescimoTaxa: opcoes.acrescimoTaxa || 0,
            diasSeparacao: opcoes.diasSeparacao || 1,
            tipoCotacao: opcoes.tipoCotacao || "",
            valorMinimoFreteGratis: (() => {
              const v = opcoes.valorMinimoFreteGratis;
              if (v === null || v === undefined) {
                return "";
              }
              if (typeof v === "string" && v.trim() === "") {
                return "";
              }
              const n = Number(String(v).replace(",", "."));
              return Number.isFinite(n) ? n : "";
            })(),
            raioFreteGratis: (() => {
              const v = opcoes.raioFreteGratis;
              if (v === null || v === undefined) {
                return "";
              }
              if (typeof v === "string" && v.trim() === "") {
                return "";
              }
              const n = Number(String(v).replace(",", "."));
              return Number.isFinite(n) ? n : "";
            })(),
            nomeFreteGratis: opcoes.nomeFreteGratis || "",
            dimensoesPacotes: opcoes.dimensoesPacotes || {
              extraPequeno: { volume: 0.0017 },
              pequeno: { volume: 0.0078 },
              medio: { volume: 0.0553 },
              grande: { volume: 0.2074 },
              extraGrande: { volume: 0.4977 }
            }
          };
          break;
      }
    },
    prepareOpcoes(form) {
      const clearCep = cep => cep.replace(/\D+/g, "");
      const convertToKilometers = value => value / 1000;
      const commonConfig = {
        id: form.id,
        idfornecedor: form.idfornecedor,
        nomeForma: form.nomeForma,
        idCalendarioEntrega: form.permiteAgendamento
          ? form.idCalendarioEntrega
          : null,
        idFormaEntregaErp: form.idFormaEntregaErp,
        tipo: form.tipo,
        canais_venda: buildCanaisVendaPayload(form.canais_venda),
        tipoFrete: form.informarTipoFrete ? form.tipoFrete : null
      };
      switch (form.tipo) {
        case "CORREIOS":
          return {
            ...commonConfig,
            credenciais: {
              usuario: form.correios.usuario,
              senha: form.correios.senha,
              cartaoPostagem: form.correios.cartaoPostagem
            },
            opcoesConfiguracao: {
              servicos: form.correios.opcoes.servicos,
              metodoCalculo: form.correios.metodoCalculo,
              cepOrigem: clearCep(form.correios.cepOrigem),
              valorDeclarado: form.correios.valorDeclarado,
              acrescimoTaxa: form.correios.acrescimoTaxa,
              diasSeparacao: form.correios.diasSeparacao
            }
          };
        case "BASEADA_CLIENTE":
          return {
            ...commonConfig,
            opcoesConfiguracao: {
              idSegmentoCliente: form.baseadaCliente.idSegmentoCliente || null,
              detalhesCustoTransporte: (form.baseadaCliente.formas || []).map(
                forma => ({
                  ...forma,
                  cepInicial: clearCep(forma.cepInicial),
                  cepFinal: clearCep(forma.cepFinal)
                })
              )
            }
          };
        case "FRENET":
          return {
            ...commonConfig,
            credenciais: { token: form.frenet.token },
            opcoesConfiguracao: {
              cepOrigem: clearCep(form.frenet.cepOrigem),
              acrescimoTaxa: form.frenet.acrescimoTaxa || 0,
              diasSeparacao: form.frenet.diasSeparacao || 1,
              permiteRestricoesFrenet:
                form.frenet.permiteRestricoesFrenet === true || false,
              transportadoras: form.frenet.transportadoras || []
            }
          };
        case "INTELIPOST":
          return {
            ...commonConfig,
            credenciais: { token: form.intelipost.token },
            opcoesConfiguracao: {
              cepOrigem: clearCep(form.intelipost.cepOrigem),
              acrescimoTaxa: form.intelipost.acrescimoTaxa || 0,
              diasSeparacao: form.intelipost.diasSeparacao || 1,
              metodoCalculo:
                form.intelipost.metodoCalculo || "DYNAMIC_BOX_ALL_ITEMS"
            }
          };
        case "TRANSPORTE":
          if (this.mode == "add") {
            return {
              ...commonConfig,
              opcoesConfiguracao: {
                detalhesCustoTransporte: form.detalhesCustoTransporte
              }
            };
          } else {
            return {
              ...commonConfig
            };
          }
        case "DELIVERY":
          return {
            ...commonConfig,
            opcoesConfiguracao: {
              valorMaxPedido: parseFloat(form.valorMaxPedido),
              valorMinPedido: parseFloat(form.valorMinPedido),
              distanciaPedidoMinimo: parseInt(form.distanciaPedidoMinimo),
              acrescimoPedMinimoPorKm: convertToKilometers(
                form.acrescimoPedMinimoPorKm
              ),
              taxaConveniencia: parseFloat(form.taxaConveniencia),
              distanciaTaxaEntrega: parseInt(form.distanciaTaxaEntrega),
              taxaExtraPorMetro: parseFloat(
                convertToKilometers(form.taxaExtraPorMetro)
              )
            }
          };
        case "RETIRADA":
          return {
            ...commonConfig,
            opcoesConfiguracao: {
              valorMaxPedido: parseFloat(form.valorMaxPedidoRetirada),
              valorMinPedido: parseFloat(form.valorMinPedidoRetirada),
              taxaColeta: parseFloat(form.taxaColeta)
            }
          };
        case "FRETE_RAPIDO":
          return {
            ...commonConfig,
            credenciais: {
              token: form.freteRapido.token,
              cnpj: form.freteRapido.cnpj,
              platformCode: form.freteRapido.platformCode
            },
            opcoesConfiguracao: {
              cepOrigem: clearCep(form.freteRapido.cepOrigem),
              layoutEtiqueta: form.freteRapido.layoutEtiqueta || "",
              formatoEtiqueta: form.freteRapido.formatoEtiqueta || "",
              acrescimoTaxa: form.freteRapido.acrescimoTaxa || 0,
              diasSeparacao: form.freteRapido.diasSeparacao || 1,
              transportadoras: form.freteRapido.transportadoras || [],
              consolidate: form.freteRapido.consolidate || false,
              overlaid: form.freteRapido.overlaid || false,
              rotate: form.freteRapido.rotate || false
            }
          };
        case "SHIPPIFY":
          return {
            ...commonConfig,
            credenciais: {
              apiId: form.shippify.apiId || "",
              apiToken: form.shippify.apiToken || "",
              companyId: form.shippify.companyId || ""
            },
            opcoesConfiguracao: {
              acrescimoTaxa: form.shippify.acrescimoTaxa || 0,
              diasSeparacao: form.shippify.diasSeparacao || 1,
              tipoCotacao: form.shippify.tipoCotacao || "",
              valorMinimoFreteGratis: (() => {
                const v = form.shippify.valorMinimoFreteGratis;
                if (v === null || v === undefined || v === "") {
                  return null;
                }
                const n = Number(v);
                return Number.isFinite(n) && n >= 0 ? n : null;
              })(),
              raioFreteGratis: (() => {
                const v = form.shippify.raioFreteGratis;
                if (v === null || v === undefined || v === "") {
                  return null;
                }
                const n = Number(v);
                return Number.isFinite(n) && n >= 0 ? n : null;
              })(),
              nomeFreteGratis: (() => {
                const valorMinimo = form.shippify.valorMinimoFreteGratis;
                const raio = form.shippify.raioFreteGratis;
                const vazio = v => v === null || v === undefined || v === "";
                if (vazio(valorMinimo) && vazio(raio)) {
                  return null;
                }
                return (form.shippify.nomeFreteGratis || "").trim() || null;
              })(),
              pickupContactName: form.shippify.pickupContactName || "",
              pickupContactEmail: form.shippify.pickupContactEmail || "",
              pickupContactPhone: form.shippify.pickupContactPhone || "",
              pickupAddress: form.shippify.pickupAddress || "",
              pickupInstructions: form.shippify.pickupInstructions || "",
              pickupLat: form.shippify.pickupLat || "",
              pickupLng: form.shippify.pickupLng || "",
              dimensoesPacotes: form.shippify.dimensoesPacotes || {
                extraPequeno: { volume: 0.0017 },
                pequeno: { volume: 0.0078 },
                medio: { volume: 0.0553 },
                grande: { volume: 0.2074 },
                extraGrande: { volume: 0.4977 }
              }
            }
          };
      }
      if (form.tipo === "TRANSPORTE" && this.mode == "add") {
        this.$vueOnToast.pop(
          "info",
          "Estamos processando os dados do arquivo."
        );
      }
      return form;
    },
    validarFormaEntrega() {
      if (this.mode == "detail") {
        return false;
      }
      const errors = [];
      this.valid = true;
      const cepValidation = (cep, message) => {
        if (!cep || cep.length !== 8) {
          errors.push(message);
          this.valid = false;
        }
      };
      if (!this.form.nomeForma) {
        errors.push("Informe o nome da forma de entrega");
        this.valid = false;
      }
      if (this.form.permiteAgendamento && !this.form.idCalendarioEntrega) {
        errors.push("Selecione o calendário");
        this.valid = false;
      }
      if (this.form.informarTipoFrete && !this.form.tipoFrete) {
        errors.push("Selecione o tipo de frete");
        this.valid = false;
      }
      if (this.form.tipo === "FRENET") {
        const frenet = this.form.frenet;
        if (frenet) {
          if (
            frenet.diasSeparacao < 0 ||
            !Number.isInteger(Number(frenet.diasSeparacao))
          ) {
            errors.push(
              "A quantidade de dias de preparo e despacho deve ser um valor inteiro positivo"
            );
            this.valid = false;
          }
          if (!frenet.token) {
            errors.push("Insira o token da API");
            this.valid = false;
          }
          if (!frenet.cepOrigem) {
            errors.push("Insira o CEP de origem");
            this.valid = false;
          }
          const cepFrenet = this.clearCep(frenet.cepOrigem);
          cepValidation(cepFrenet, "CEP inválido para a Forma de Entrega");
        }
      }
      if (this.form.tipo === "INTELIPOST") {
        const intelipost = this.form.intelipost;
        if (intelipost) {
          if (!intelipost.token) {
            errors.push("Insira o token da API");
            this.valid = false;
          }
          if (!intelipost.cepOrigem) {
            errors.push("Insira o CEP de origem");
            this.valid = false;
          }
          if (
            intelipost.diasSeparacao < 0 ||
            !Number.isInteger(Number(intelipost.diasSeparacao))
          ) {
            errors.push(
              "A quantidade de dias de separação deve ser um valor inteiro positivo"
            );
            this.valid = false;
          }
          const cepFrenet = this.clearCep(intelipost.cepOrigem);
          cepValidation(cepFrenet, "CEP inválido para a Forma de Entrega");
        }
      }
      if (this.form.tipo === "BASEADA_CLIENTE") {
        const formaEntregaClienteForm = this.getFormaEntregaClienteFormRef();
        formaEntregaClienteForm?.touchValidations?.();
        const baseadaCliente = this.form.baseadaCliente;
        if (baseadaCliente) {
          if (!baseadaCliente.idSegmentoCliente) {
            errors.push("Selecione o segmento do cliente");
            this.valid = false;
          }
          const formaPendente =
            formaEntregaClienteForm?.getFormaTransportePendente?.() || null;
          const transporteErrors = validarDetalhesTransporteCliente(
            baseadaCliente.formas,
            formaPendente
          );
          transporteErrors.forEach(error => {
            errors.push(error);
            this.valid = false;
          });
        }
      }
      if (this.form.tipo === "CORREIOS") {
        const correios = this.form.correios;
        if (correios) {
          const cepCorreios = this.clearCep(correios.cepOrigem);
          cepValidation(cepCorreios, "CEP inválido para os Correios");
        }
        if (
          correios.diasSeparacao < 0 ||
          !Number.isInteger(Number(correios.diasSeparacao))
        ) {
          errors.push(
            "A quantidade de dias de preparo e despacho deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
      }
      if (this.form.tipo === "DELIVERY") {
        if (this.form.valorMaxPedido <= 0) {
          errors.push(
            "O valor máximo do pedido não pode ser 0 (zero) para entrega"
          );
          this.valid = false;
        }
        if (
          this.form.valorMinPedido < 0 ||
          !Number.isInteger(Number(this.form.valorMinPedido))
        ) {
          errors.push(
            "O valor mínimo do pedido deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
        if (
          this.form.distanciaPedidoMinimo < 0 ||
          !Number.isInteger(Number(this.form.distanciaPedidoMinimo))
        ) {
          errors.push(
            "A distância mínima do pedido deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
        if (
          this.form.acrescimoPedMinimoPorKm < 0 ||
          !Number.isInteger(Number(this.form.acrescimoPedMinimoPorKm))
        ) {
          errors.push(
            "O acrescimo do pedido mínimo deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
        if (
          this.form.taxaConveniencia < 0 ||
          !Number.isInteger(Number(this.form.taxaConveniencia))
        ) {
          errors.push("O valor base deve ser um valor inteiro positivo");
          this.valid = false;
        }
        if (
          this.form.distanciaTaxaEntrega < 0 ||
          !Number.isInteger(Number(this.form.distanciaTaxaEntrega))
        ) {
          errors.push(
            "A distância para a base deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
        if (
          this.form.taxaExtraPorMetro < 0 ||
          !Number.isInteger(Number(this.form.taxaExtraPorMetro))
        ) {
          errors.push("A taxa extra deve ser um valor inteiro positivo");
          this.valid = false;
        }
      }
      if (this.form.tipo === "RETIRADA") {
        if (
          this.form.valorMaxPedidoRetirada <= 0 ||
          !Number.isInteger(Number(this.form.valorMaxPedidoRetirada))
        ) {
          errors.push(
            "O valor máximo do pedido não pode ser 0 (zero) para retirada"
          );
          this.valid = false;
        }
        if (
          this.form.valorMinPedidoRetirada < 0 ||
          !Number.isInteger(Number(this.form.valorMinPedidoRetirada))
        ) {
          errors.push(
            "O valor mínimo do pedido deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
        if (
          this.form.taxaColeta < 0 ||
          !Number.isInteger(Number(this.form.taxaColeta))
        ) {
          errors.push(
            "A taxa de coveniência do pedido deve ser um valor inteiro positivo"
          );
          this.valid = false;
        }
      }
      if (this.form.tipo === "TRANSPORTE") {
        if (this.mode == "add") {
          if (
            !this.form.detalhesCustoTransporte ||
            this.form.detalhesCustoTransporte.length === 0
          ) {
            errors.push(
              "Obrigatório selecionar um arquivo para o cadastro da forma de entrega do tipo Transporte!"
            );
            this.valid = false;
          }
        }
      }
      if (this.form.tipo === "FRETE_RAPIDO") {
        const freteRapido = this.form.freteRapido;
        if (freteRapido) {
          if (
            freteRapido.diasSeparacao < 0 ||
            !Number.isInteger(Number(freteRapido.diasSeparacao))
          ) {
            errors.push(
              "A quantidade de dias de preparo e despacho deve ser um valor inteiro positivo"
            );
            this.valid = false;
          }
          if (!freteRapido.cnpj) {
            errors.push("Insira o Cnpj da empresa vinculada ao Frete Rápido");
            this.valid = false;
          }
          if (!freteRapido.token) {
            errors.push("Insira o token da API");
            this.valid = false;
          }
          if (!freteRapido.platformCode) {
            errors.push("Insira o código da plataforma da API");
            this.valid = false;
          }
          if (!freteRapido.cepOrigem) {
            errors.push("Insira o CEP de origem");
            this.valid = false;
          }
          if (!freteRapido.layoutEtiqueta) {
            errors.push("Insira o layout da etiqueta");
            this.valid = false;
          }
          if (!freteRapido.formatoEtiqueta) {
            errors.push("Insira o formato da etiqueta");
            this.valid = false;
          }
          const cepFreteRapido = this.clearCep(freteRapido.cepOrigem);
          cepValidation(cepFreteRapido, "CEP inválido para a Forma de Entrega");
        }
      }
      if (this.form.tipo === "SHIPPIFY") {
        const shippify = this.form.shippify;
        if (shippify) {
          if (!shippify.apiId) {
            errors.push("Insira o API ID");
            this.valid = false;
          }
          if (!shippify.apiToken) {
            errors.push("Insira o API Token");
            this.valid = false;
          }
          if (!shippify.companyId) {
            errors.push("Insira o Company ID");
            this.valid = false;
          }
          if (!shippify.pickupContactName) {
            errors.push("Insira o nome do responsável pela coleta");
            this.valid = false;
          }
          if (!shippify.pickupContactEmail) {
            errors.push("Insira o e-mail do responsável pela coleta");
            this.valid = false;
          }
          if (!shippify.pickupAddress) {
            errors.push("Insira o endereço completo de coleta");
            this.valid = false;
          }
          if (
            shippify.diasSeparacao < 0 ||
            !Number.isInteger(Number(shippify.diasSeparacao))
          ) {
            errors.push(
              "A quantidade de dias de preparo e despacho deve ser um valor inteiro positivo"
            );
            this.valid = false;
          }
          if (!shippify.tipoCotacao) {
            errors.push("Selecione o tipo da cotação");
            this.valid = false;
          }
          const raio = shippify.raioFreteGratis;
          if (raio !== null && raio !== undefined && raio !== "") {
            const n = Number(raio);
            if (!Number.isFinite(n) || n < 0) {
              errors.push(
                "O raio de frete grátis deve ser um número não negativo, em quilômetros"
              );
              this.valid = false;
            }
          }
        }
      }
      if (!this.valid) {
        this.$vueOnToast.pop("error", errors.join(" - "));
      }

      return this.valid;
    },
    maskCep(cep) {
      const cepAddress = String(cep).replace(/[^0-9-]/g, "");
      const numericCep = cepAddress.replace(/\D/g, "");
      const limitedCep = numericCep.substring(0, 8);
      return this.formatCep(limitedCep);
    },
    formatCep(limitedCep) {
      if (limitedCep.length >= 8) {
        const formattedCep = limitedCep.replace(/(\d{5})(\d{3})$/, "$1-$2");
        return formattedCep;
      }
      return limitedCep;
    },
    clearCep(cep) {
      return cep ? cep.replace("-", "") : "";
    }
  },
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "moduloFornecedorAtivo",
      "getFornecedorTag"
    ]),
    formasEntrega() {
      return Object.keys(FORMASENTREGAS).map(chave => ({
        label: FORMASENTREGAS[chave],
        value: chave
      }));
    },
    endpoint() {
      return `api/v4/forma-entrega/detalhes-custo-transporte/${this.form.id}/${this.getFornecedorId}`;
    },
    title() {
      return this.mode == "edit"
        ? "Editar forma de entrega"
        : "Nova  forma de entrega";
    },
    formasEntregas() {
      if (this.mode == "edit") {
        return this.formasEntrega
          .filter(fe => fe.value == this.form.tipo)
          .map(f => {
            return { ...f, show: true };
          });
      } else {
        return this.formasEntrega.map(forma => {
          let obj = {};
          if (forma.value === "DELIVERY") {
            obj = {
              ...forma,
              show: this.form.showDelivery || this.mode == "edit"
            };
          } else if (forma.value === "RETIRADA") {
            obj = {
              ...forma,
              show: this.form.showRetirada || this.mode == "edit"
            };
          } else {
            obj = { ...forma, show: true };
          }
          return obj;
        });
      }
    }
  },
  watch: {
    "form.informarTipoFrete"(informar) {
      if (!informar) {
        this.form.tipoFrete = null;
      }
    },
    "form.canais_venda": {
      deep: true,
      handler(val) {
        const normalized = normalizeCanaisVendaFromApi(val);
        if (!_.isEqual(val, normalized)) {
          this.form.canais_venda = normalized;
        }
      }
    }
  },
  created() {
    this.form.id = this.$route.params.idformaentrega;
    this.form.nomeForma = this.$route.query.nomeForma;
    this.getFornecedor();
    this.getCalendarios();
  }
};
</script>
